import React, { PropTypes } from 'react';

import styled from 'styled-components';

const Text = styled.span`
  display: inline-block;
  text-transform: lowercase;
  &:first-letter {
    text-transform: uppercase;
  }
`;

const TransformText = ({ data }) => {
  return <Text>{data}</Text>;
};

export default TransformText;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/TransformText.js